import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { ProductStockRecord, StockMap } from '@pedix-workspace/shared-stock';
import { CartItem } from '@pedix-workspace/utils';

@Injectable({ providedIn: 'root' })
export class StockService {
  readonly parentStockService = inject(StockService, { skipSelf: true, optional: true });

  productStock = signal<ProductStockRecord[]>([]);
  cartItems = signal<CartItem[]>([]);
  originalCartItems = signal<CartItem[]>([]);
  stockCheckDisabled = signal<boolean>(false);

  stock = computed<StockMap>(
    () =>
      new StockMap(
        this.productStock(),
        this.cartItems(),
        this.originalCartItems(),
        this.stockCheckDisabled(),
      ),
  );

  constructor() {
    const parent = this.parentStockService;

    if (parent) {
      this.cartItems.set(parent.cartItems());
      this.originalCartItems.set(parent.originalCartItems());

      // productStock/stockCheckDisabled son GLOBALES → espejar el parent de forma REACTIVA para que las
      // actualizaciones async (ej. el fetch de /stock que resuelve después de crear este child) propaguen.
      effect(() => this.productStock.set(parent.productStock()));
      effect(() => this.stockCheckDisabled.set(parent.stockCheckDisabled()));
    }
  }

  /**
   * "Sin stock" resuelto contra el stock REAL (`productStock` vía StockMap). Con
   * presentaciones, el producto está sin stock si TODAS lo están; una entidad sin
   * record es infinita y nunca cuenta como sin stock.
   */
  isProductWithoutStock(product: {
    id: string;
    presentationItems?: { id: string }[];
  }): boolean {
    const stock = this.stock();

    if (Array.isArray(product.presentationItems)) {
      return product.presentationItems.every(
        item => stock.getStockInfoByItem(item.id).isOutOfStock,
      );
    }
    return stock.getStockInfoByItem(product.id).isOutOfStock;
  }
}
